import i18n from '@/i18n';
import { getKeycloak, getToken } from '@nxtpeople/nxt-vue-keycloak';
import axios, { AxiosError, AxiosResponse } from 'axios';
import router from '../router';

const authRequestInterceptor = async function (config: any) {
   const token = await getToken();

   config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
      Accept: `application/json`,
   };

   return config;
};

const authResponseSuccessInterceptors = async function (response: AxiosResponse) {
   return response;
};

const authResponseErrorInterceptors = async function (error: AxiosError) {
   if (axios.isCancel(error)) return await Promise.reject(error);

   if (!error?.response) {
      router.push({
         path: '/error',
         query: {
            error_code: i18n.global.t('errors.error'),
            error_title: i18n.global.t('generic.feedback.something-went-wrong'),
            error_message: i18n.global.t('generic.feedback.contact-support'),
            error_navigate_text: i18n.global.t('actions.refresh'),
            error_navigate_path: window.location.origin,
         },
      });

      return await Promise.reject(error);
   }

   const { status, headers } = error.response;

   if (status === 401) {
      router.push({
         path: '/error',
         query: {
            error_code: '401',
            error_title: i18n.global.t('errors.account-not-found'),
            error_message: i18n.global.t('generic.account-not-found-description'),
            error_navigate_text: i18n.global.t('actions.log-out'),
            error_navigate_path: getKeycloak().createLogoutUrl({ redirectUri: window.location.origin }),
         },
      });
   }
   if (status === 403 && !headers?.location) {
      router.push({
         path: '/error',
         query: {
            error_code: '403',
            error_title: i18n.global.t('generic.access-denied'),
            error_message: i18n.global.t('generic.u-have-no-access'),
            error_navigate_text: i18n.global.t('generic.back-to-home-screen'),
            error_navigate_path: window.location.origin,
         },
      });
   }

   return await Promise.reject(error);
};

export { authRequestInterceptor, authResponseErrorInterceptors, authResponseSuccessInterceptors };
